import api from 'services/api/microfwk';
import _ from 'lodash';

export const getModify = (params = {}) =>
  api
    .get('/services/user/modify', {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', 0);
      if (parseInt(status, 10) !== 0) return _.get(data, 'errors', false);
      return data.response;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const userCompleteModify = (body, params = {}) => {
  const formData = new FormData();
  Object.keys(body).map(key => {
    formData.append(key, body[key]);
    return key;
  });
  return api
    .post('/services/user/modify', formData, {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', 0);
      if (parseInt(status, 10) !== 0) return _.get(data, 'errors', false);
      return data.response;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
}
